import React from 'react'
import { digitsOnly } from '../lib/claimContactFormat'

function normDigits(value) {
  return String(value ?? '').replace(/\D/g, '')
}

/** 휴대폰 등: 부분 문자열로 분해 (표시용) */
export function splitPhonePartsForInputs(value) {
  const digits = normDigits(value).slice(0, 11)
  if (!digits) return ['', '', '']
  if (digits.startsWith('02') && digits.length <= 10) {
    const a = digits.slice(0, 2)
    const rest = digits.slice(2)
    if (rest.length <= 4) return [a, rest, '']
    return [a, rest.slice(0, 4), rest.slice(4, 8)]
  }
  if (digits.length <= 3) return [digits, '', '']
  if (digits.length <= 7) return [digits.slice(0, 3), digits.slice(3), '']
  return [digits.slice(0, 3), digits.slice(3, 7), digits.slice(7, 11)]
}

export function ResidentDigitsSplitInput({ value, onChange, disabled, idPrefix = 'rrn' }) {
  const full = normDigits(value).slice(0, 13)
  const f = full.slice(0, 6)
  const b = full.slice(6, 13)
  return (
    <div className="flex flex-wrap items-center gap-2">
      <input
        id={`${idPrefix}-front`}
        className="min-w-0 w-[7.5rem] rounded border px-3 py-2 text-sm tabular-nums"
        inputMode="numeric"
        autoComplete="off"
        maxLength={6}
        disabled={disabled}
        value={f}
        placeholder="앞 6자리"
        aria-label="주민등록번호 앞자리"
        onChange={(e) => onChange(`${digitsOnly(e.target.value, 6)}${b}`)}
      />
      <span className="select-none text-slate-400">-</span>
      <input
        id={`${idPrefix}-back`}
        className="min-w-0 w-[8.5rem] rounded border px-3 py-2 text-sm tabular-nums tracking-wider"
        inputMode="numeric"
        autoComplete="off"
        maxLength={7}
        disabled={disabled}
        value={b}
        placeholder="뒤 7자리"
        aria-label="주민등록번호 뒷자리"
        onChange={(e) => onChange(`${f}${digitsOnly(e.target.value, 7)}`)}
      />
    </div>
  )
}

export function PhoneDigitsSplitInput({ value, onChange, disabled, idPrefix = 'ph' }) {
  const [p1, p2, p3] = splitPhonePartsForInputs(value)
  const merged = (a, b, c) => onChange(normDigits(`${a}${b}${c}`).slice(0, 11))
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <input
        id={`${idPrefix}-0`}
        className="min-w-0 w-[3.25rem] rounded border px-2 py-2 text-center text-sm tabular-nums sm:w-[3.5rem]"
        inputMode="numeric"
        autoComplete="off"
        maxLength={3}
        disabled={disabled}
        value={p1}
        placeholder="010"
        aria-label="휴대폰 앞자리"
        onChange={(e) => merged(digitsOnly(e.target.value, 3), p2, p3)}
      />
      <span className="select-none text-slate-300">-</span>
      <input
        id={`${idPrefix}-1`}
        className="min-w-0 w-[4rem] rounded border px-2 py-2 text-center text-sm tabular-nums sm:w-[4.5rem]"
        inputMode="numeric"
        autoComplete="off"
        maxLength={4}
        disabled={disabled}
        value={p2}
        placeholder="0000"
        aria-label="휴대폰 중간"
        onChange={(e) => merged(p1, digitsOnly(e.target.value, 4), p3)}
      />
      <span className="select-none text-slate-300">-</span>
      <input
        id={`${idPrefix}-2`}
        className="min-w-0 w-[4rem] rounded border px-2 py-2 text-center text-sm tabular-nums sm:w-[4.5rem]"
        inputMode="numeric"
        autoComplete="off"
        maxLength={4}
        disabled={disabled}
        value={p3}
        placeholder="0000"
        aria-label="휴대폰 끝자리"
        onChange={(e) => merged(p1, p2, digitsOnly(e.target.value, 4))}
      />
    </div>
  )
}
